<template>
  <div class="kpis">
    <StatisticsKpi label="Encaissé net TTC" :value="money(k.netTtc)" hint="Remboursements déduits" />
    <StatisticsKpi label="Encaissé net HT" :value="money(k.netHt)" hint="Au prorata de la TVA des contrats" />
    <StatisticsKpi label="Encaissements reçus" :value="money(k.receivedTtc)" :hint="`${integer(k.count)} mouvement(s) au total`" />
    <StatisticsKpi label="Remboursements" :value="money(k.refundedTtc)" :tone="k.refundedTtc ? 'warn' : ''" />
    <StatisticsKpi label="Encaissement moyen" :value="money(k.averageAmount)" hint="Par règlement reçu" />
  </div>
  <div class="charts">
    <StatisticsCard :span="12" title="Encaissements par période" subtitle="Montants TTC reçus, remboursés (en négatif) et solde net" :empty="!hasData(data.series.flatMap(row => [row.received, row.refunded]))">
      <StatisticsChart stacked :labels="labels" :datasets="datasets" />
    </StatisticsCard>
    <StatisticsCard :span="6" title="Modes de paiement" subtitle="Montant net TTC par mode" :empty="!positiveTypes.length">
      <StatisticsChart type="doughnut" :labels="positiveTypes.map(item => paymentType(item.key))" :datasets="[{label: 'TTC', data: positiveTypes.map(item => item.amount)}]" />
    </StatisticsCard>
    <StatisticsCard :span="6" title="Motifs des encaissements" subtitle="Montant net TTC par motif" :empty="!positivePurposes.length">
      <StatisticsChart type="doughnut" :labels="positivePurposes.map(item => purposeLabel(item.key))" :datasets="[{label: 'TTC', data: positivePurposes.map(item => item.amount)}]" />
    </StatisticsCard>
  </div>
</template>

<script>
import StatisticsKpi from "@/statistics/components/StatisticsKpi.vue";
import StatisticsCard from "@/statistics/components/StatisticsCard.vue";
import StatisticsChart from "@/statistics/components/StatisticsChart.vue";
import {bucketLabel, hasData, integer, money} from "@/statistics/utils/format";
import {NEGATIVE_COLOR, PALETTE} from "@/statistics/utils/chartTheme";
import {convertPaymentType} from "@/utils";
import {PAYMENT_PURPOSE} from "@/models/paymentPurpose";

/**
 * Encaissements : trésorerie reçue et remboursée dans le temps, par mode de paiement et par motif.
 */
export default {
  name: 'CollectionsStats',
  components: {StatisticsKpi, StatisticsCard, StatisticsChart},
  props: {
    data: {type: Object, required: true},
  },
  computed: {
    k() {
      return this.data.kpis;
    },
    labels() {
      return this.data.series.map(row => bucketLabel(row.key));
    },
    datasets() {
      return [
        {label: 'Reçus', data: this.data.series.map(row => row.received), color: PALETTE[0]},
        {label: 'Remboursés', data: this.data.series.map(row => -row.refunded), color: NEGATIVE_COLOR},
        {label: 'Solde net', data: this.data.series.map(row => row.net), type: 'line', color: PALETTE[2]},
      ];
    },
    // Un anneau ne montre que des parts positives : un mode ou motif au solde négatif n'en a pas
    positiveTypes() {
      return this.data.byPaymentType.filter(item => item.amount > 0);
    },
    positivePurposes() {
      return this.data.byPurpose.filter(item => item.amount > 0);
    },
  },
  methods: {
    money, integer, hasData,
    paymentType: convertPaymentType,
    purposeLabel: key => PAYMENT_PURPOSE[key]?.label ?? key,
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/statistics/style/statistics.styl';
</style>
